import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NewsletterSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-secondary-900">
      <div className="max-w-2xl mx-auto text-center">
        <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-3">
          {t('newsletterTitle')}
        </h3>
        <p className="text-sm text-secondary-400 mb-8">
          {t('newsletterSubtitle')}
        </p>
        <form
          className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          data-readdy-form="newsletter"
          action="https://readdy.ai/api/form/d9qoi2ue3oq4jqumto1g"
          method="POST"
        >
          <input
            type="email"
            name="email"
            placeholder={t('newsletterPlaceholder')}
            required
            className="w-full h-11 px-4 text-sm rounded-full border border-secondary-700 bg-secondary-800 text-background-50 placeholder-secondary-500 focus:outline-none focus:border-accent-400 transition-all"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="form-honeypot"
          />
          <button
            type="submit"
            className="w-full sm:w-auto px-8 h-11 bg-accent-500 text-secondary-900 rounded-full text-sm font-semibold hover:bg-accent-400 transition-all whitespace-nowrap cursor-pointer"
          >
            {t('newsletterButton')}
          </button>
        </form>
      </div>
    </section>
  );
}